export interface DocumentosTecnicosModel {
  index: number;
  tipo_documento: string;
  descripcion: string;
  url_documento: string;
  activo: boolean;
}

export const initialValuesDocumentosTecnicosModel = {
  index: 0,
  tipo_documento: "",
  descripcion: "",
  url_documento: "",
  activo: false,
};
